module.exports = __webpack_public_path__ + "media/images/file-icons/256/005-database-8c4f050ff3b88713427fad1eaf44c927.png";